import { useState, useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { message } from "antd";
import { Modal } from "../../assets/AntDesign/Modal";
import { ROUTES } from "../../routes/patientRoutes/routePaths";
import { validateNewPassword } from "../functions/validators/validateNewPassword";

import { resetPassword } from "../redux/thunks/authThunks";

export default function useSetNewPassword() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const email = location.state?.email || "";
  const resetCode = location.state?.resetCode || "";

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!email || !resetCode) {
      navigate(ROUTES.FORGOT_PASSWORD, { replace: true });
    }
  }, [email, resetCode, navigate]);

  const handleReset = useCallback(async () => {
    const { ok, error: errMsg } = validateNewPassword(password, confirmPassword);
    if (!ok) {
      setError(errMsg);
      return;
    }

    setError("");
    setLoading(true);
    try {
      await dispatch(
        resetPassword({
          email,
          resetCode,
          newPassword: password,
          confirmPassword,
        })
      ).unwrap();

      message.success("Password successfully reset!");
      navigate(ROUTES.LOGIN, { replace: true });
    } catch (err) {
      const msg = typeof err === "string" ? err : "Failed to reset password";
      setError(msg);
      Modal.error({ title: "Reset failed", content: msg });
    } finally {
      setLoading(false);
    }
  }, [dispatch, email, resetCode, password, confirmPassword, navigate]);

  const onKeyDown = useCallback(
    (e) => {
      if (e.key === "Enter" && !loading) handleReset();
    },
    [handleReset, loading]
  );

  const goLogin = useCallback(() => navigate(ROUTES.LOGIN), [navigate]);

  return {
    password,
    confirmPassword,
    error,
    loading,
    setPassword,
    setConfirmPassword,
    setError,
    handleReset,
    onKeyDown,
    goLogin,
  };
}